import { Controller } from "@hotwired/stimulus"

// Shows an image preview when a file input changes.
// Place on a container; listens for change on any input[type=file].has-preview within.
export default class extends Controller {
  connect() {
    if (typeof FileReader !== 'function') return
    this.changeHandler = this.showPreview.bind(this)
    this.element.addEventListener('change', this.changeHandler)
  }

  disconnect() {
    if (this.changeHandler) {
      this.element.removeEventListener('change', this.changeHandler)
    }
  }

  showPreview(event) {
    const input = event.target
    if (!input.matches('input[type=file].has-preview')) return

    const $input = jQuery(input)
    let $preview = $input.parent().find('.file-preview')
    if (!$preview.length) $preview = jQuery('.file-preview')

    $preview.removeClass('hide')
    const reader = new FileReader()
    reader.readAsDataURL(input.files[0])
    reader.onload = function(e) {
      $preview.get(0).src = e.target.result
    }
  }
}
